
export function formatCPF(cpf) {
  let valueNotMask = removeMask(cpf);
  // valueNotMask = valueNotMask.split('').filter(n => (Number(n))).join('');
  valueNotMask = removeCharacter(valueNotMask);
  if (valueNotMask.length > 0) {
    if (valueNotMask.length > 11) {
      valueNotMask = valueNotMask.substring(0, 11);
    }
  }
  return maskCPF(valueNotMask);
}
export function maskCPF(cpf) {
  cpf = cpf.replace(/\D/g, '');
  cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
  cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
  cpf = cpf.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
  return cpf;
}

export function removeMask(value) {
  value = value.replaceAll('.', '').replaceAll('-', '');
  return value;
}

export function removeCharacter(value) {
  var character = '';
  var result = '';
  for (let count = 0; count < value.length; count++) {
    character = value.substring(count, count + 1);
    if (/^\d+$/.test(character)) {
      result += character;
    }
  }
  return result;
}

export function formatElectoralTitle(titleNumber) {
  let valueNotMask = removeMask(titleNumber);
  valueNotMask = removeCharacter(valueNotMask);
  if (valueNotMask.length > 0) {
    if (valueNotMask.length > 11) {
      valueNotMask = valueNotMask.substring(0, 12);
    }
  }
  return maskElectoralTitle(valueNotMask);
}
export function maskElectoralTitle(titleNumber) {
  titleNumber = titleNumber.replace(/\D/g, '');
  titleNumber = titleNumber.replace(/(\d{4})(\d)/, '$1.$2');
  titleNumber = titleNumber.replace(/(\d{4})(\d)/, '$1.$2');
  titleNumber = titleNumber.replace(/(\d{4})(\d)/, '$1.$2');
  return titleNumber;
}
export function isMobile() {
  const mobileBrowsers = [/Android/i, /webOS/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /Windows Phone/i];
  const lengthAll = mobileBrowsers.length;
  let result = false;
  for (let i = 0; i < lengthAll; i++) {
    const itemMobile = mobileBrowsers[i];
    if (!result) {
      if (navigator.userAgent.match(itemMobile)) {
        result = true;
      }
    }
  }
  return result;
}

export function convertBool(value) {
  return (value.toUpperCase() === 'TRUE');
}

export default { formatCPF, maskCPF, removeMask, removeCharacter, formatElectoralTitle, isMobile, convertBool };
